// extracted by mini-css-extract-plugin
module.exports = {"dividerMobile":"header-module--dividerMobile--34nPT"};